export default "__VITE_ASSET__B38Lnk39__"